import React, { useState, useRef, useEffect } from "react";
import { DateRangePicker } from "react-date-range";
import { format } from "date-fns";
import "react-date-range/dist/styles.css"; // Main style file
import "react-date-range/dist/theme/default.css"; // Theme CSS file

const DateRangeFilter = ({ column, handleInputFilterChangeNoDebounce }) => {
   const [selectedRange, setSelectedRange] = useState({
      startDate: new Date(column?.value?.startDate || new Date()),
      endDate: new Date(column?.value?.endDate || new Date()),
      key: "selection",
   });
   const [isVisible, setIsVisible] = useState(false);
   const pickerRef = useRef();
   const pendingStartRef = useRef(false);

   useEffect(() => {
      const handleClickOutside = (event) => {
         if (pickerRef.current && !pickerRef.current.contains(event.target)) {
            setIsVisible(false);
            pendingStartRef.current = false;
         }
      };
      document.addEventListener("mousedown", handleClickOutside);
      return () => document.removeEventListener("mousedown", handleClickOutside);
   }, []);

   const togglePicker = () => {
      setIsVisible((prev) => {
         if (!prev) pendingStartRef.current = false;
         return !prev;
      });
   };

   useEffect(() => {
      if (column.value) {
         const { startDate, endDate } = column.value;
         setSelectedRange((prev) => ({
            ...prev,
            startDate: new Date(startDate),
            endDate: new Date(endDate),
         }));
      } else {
         setSelectedRange({
            startDate: new Date(),
            endDate: new Date(),
            key: "selection",
         });
      }
   }, [column.value]);

   const handleDateChange = (range) => {
      const { selection } = range;
      setSelectedRange(selection);
      handleInputFilterChangeNoDebounce(column.id, selection);

      const isSameDay = selection.startDate.getTime() === selection.endDate.getTime();

      if (!isSameDay) {
         // Multi-day range: either a predefined range (Last Week, Last Month, etc.)
         // or the second calendar click with a different end date. Close the picker.
         setIsVisible(false);
         pendingStartRef.current = false;
      } else if (pendingStartRef.current) {
         // Second calendar click on the same day — single-day range is complete.
         setIsVisible(false);
         pendingStartRef.current = false;
      } else {
         // First calendar click — keep picker open for end-date selection.
         pendingStartRef.current = true;
      }
   };

   return (
      <div style={{ position: "relative" }}>
         <input type="text" placeholder="Date Range" className="form-control mt-2" readOnly onClick={togglePicker}
         value={`${selectedRange.startDate ? format(selectedRange.startDate, "yyyy-MM-dd") : ""} - ${selectedRange.endDate ? format(selectedRange.endDate, "yyyy-MM-dd") : ""}`} />
         {isVisible && (
            <div ref={pickerRef} style={{ position: "absolute", zIndex: 10, background: "#fff", border: "1px solid #ccc" }}>
               <DateRangePicker ranges={[selectedRange]} onChange={handleDateChange} />
            </div>
         )}
      </div>
   );
};

export default DateRangeFilter;
